import React, { useState } from "react";
import { useSelector } from "react-redux";
import { truncateUrl } from "common/helper";
import { ModalBody, ModalFooter } from "application/modal/index";
import { useModelPopup } from "common/hooks";
import styles from "../taskInfo.module.scss";

import { Button, BtnType, Loading, Label } from "../../../../../primitives";

const AddDocumentLink = ({ savedocument }) => {
  const {
    documentsReducer: { loadingDocs },
  } = useSelector((state) => state);
  const popup = useModelPopup();

  const [docLink, setDocLink] = useState("");
  const [docTitle, setDocTitle] = useState("");
  const [linkrequiredError, setErrorRequired] = useState(false);

  if (loadingDocs) {
    return <Loading />;
  }

  const submitLink = () => {
    if (docLink === "") {
      setErrorRequired(true);
      return;
    }
    savedocument(docLink, docTitle || truncateUrl(docLink), "link");
    popup.hide();
  };

  return (
    <div>
      <ModalBody>
        <Label>Title</Label>

        <input
          className="w-100 border small p-2 mb-3"
          placeholder="Add a title"
          onChange={(evt) => setDocTitle(evt.target.value)}
        />
        <Label>Link</Label>
        <input
          className="w-100 border small p-2 mb-3"
          placeholder="Add a link to a document"
          onChange={(evt) => {
            setDocLink(evt.target.value);
            setErrorRequired(false);
          }}
        />
        {linkrequiredError && (
          <span className={styles.errorMsg}> Link is required </span>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            popup.hide();
          }}
          btn={BtnType.FRAME_LESS}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            submitLink();
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </div>
  );
};

export default AddDocumentLink;
